<script setup lang="ts">
import { computed, ref } from 'vue';
import { every, isEmpty } from 'lodash';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import { useComponentComposable } from '@/components/useComponentComposable';
import ShowImageByScreen from '@/components/ShowImageByScreen.vue';

const props = defineProps<{
  showHide?: object;
  value: object[];
}>();

const displayTermsAndConditions = ref(false);
const termData = ref('');
const { renderHTMLContent } = useComponentComposable();
const showTermsAndConditions = (data) => {
  termData.value = data;
  displayTermsAndConditions.value = true;
};

const isEmptyDetail = computed(() => {
  return every(props.value, isEmpty);
});
</script>
<template>
  <div :class="{ show: !showHide }" class="form-promo" v-if="!isEmptyDetail">
    <div v-for="(promo, promoIndex) in value" :key="'formPromo' + promoIndex">
      <p class="line-height-3 m-0"></p>
      <div class="w-full flex justify-content-center">
        <div class="max-w-max">
          <ShowImageByScreen alt="image-render" class="w-full border-round-top img" :images="promo.renderImage"></ShowImageByScreen>
        </div>
      </div>
      <renderHTMLContent class="font-bold text-3xl heading-font text-900 my-2" :data="promo.title"></renderHTMLContent>
      <renderHTMLContent class="my-2 break-word" :data="promo.description"></renderHTMLContent>
      <div class="p-3 text-left">
        <a v-if="promo.TC" class="text-left cursor-pointer" @click="showTermsAndConditions(promo.TC)">{{ $t('promos.labels.term') }}</a>
      </div>
      <Divider layout="horizontal" align="center" class="mt-5 mb-6" v-if="value.length > 1 && promoIndex === 0">
        <span class="p-tag bg-primary hidden">{{ $t('common.and') }}</span>
      </Divider>
    </div>
    <Dialog :header="$t('common.termcondition')" :modal="true" :position="'center'" v-model:visible="displayTermsAndConditions" class="tcs-top w-6">
      <renderHTMLContent :data="termData"></renderHTMLContent>
    </Dialog>
  </div>
</template>
<style lang="scss">
.form-promo {
  .img {
    object-fit: cover;
    object-position: center;
  }
}
.custom-dialog-50vw {
  width: 50vw;
}
</style>
